import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-maintenance-mode-popup",
  templateUrl: "./maintenance-mode-popup.component.html",
  styleUrls: ["./maintenance-mode-popup.component.css"],
})
export class MaintenanceModePopupComponent implements OnInit {
  form: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<MaintenanceModePopupComponent>,
  ) {
    console.log(data);
    this.form = data;
  }

  ngOnInit() {}
}
